import Navbar from "../../components/Navbar/Navbar";

import React, { useEffect, useState } from "react";
import image from "../../assets/Images/roundimage.png";
import { Image } from "antd";
import { Breadcrumb } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import { routes } from "../../Routes";
import { useSelector } from "react-redux";
import BDODetails from "../../components/Profile/BDODetails";
import { store } from "../../Redux/store";
import { useTranslation } from "react-i18next";
import "../../styles.css";

import BasicCashierSettings from "../../components/CashierSetup/BasicCashierSettings";
import CashierModulesAccess from "../../components/CashierSetup/CashierModulesAccess";
import { GetRetailerDetails } from "../../API  Functions/ProfileFunctions";
import StoreModuleAccess from "./StoreModuleAccess";
import UserAccessSettings from "./UserAccessSettings";


const UserAccessManagement = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector((state) => state.login?.user?.store_id);
  const company_name = useSelector(
    (state) => state?.login?.user?.result?.company_name,
  );
  const image_url = useSelector(
    (state) => state?.login?.user?.result?.image_url,
  );
     const userInfo = useSelector((state) => state?.login?.user?.result);
  const [retailerData, setretailerData] = useState({});
  const isRetailer = userInfo?.is_retailer;
const isSubStore = userInfo?.is_sub_store;
const isWarehouse = userInfo?.is_warehouse;
  const defaultTab = (isRetailer && !isSubStore && !isWarehouse)
  ? "Basic Settings"
  : "Store Module Access";
const [selectedValue, setSelectedValue] = useState(defaultTab);


  


  useEffect(() => {
    fetchdetails();
  }, []);

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setretailerData(result?.retailer_details);
      }
    });
  };

const data = [
  ...(isRetailer && !isSubStore && !isWarehouse
    ? [{
        name: "Basic Settings",
        component: <UserAccessSettings retailerDetails={retailerData} />,
      }]
    : []),
  {
    name: "Store Module Access",
    component: <StoreModuleAccess />,
  },
];
  //
  return (
    <div className="h-screen flex flex-col bg-[#F6F7F9]">
      <div className="sticky top-0 md:z-50 bg-[#F6F7F9]">
        <Navbar heading="User Access Management" />
      </div>

      <div className="flex-1 overflow-hidden px-3 mt-4 mb-4">
        <div className="bg-white rounded-xl h-full flex flex-col">
          <div className="sticky top-0 z-40 bg-white border-b px-4 py-3 flex gap-4 overflow-x-auto">
            {data.map((val, i) => (
              <div
                key={i}
                onClick={() => setSelectedValue(val.name)}
                className={`cursor-pointer px-4 py-2 rounded-md font-medium whitespace-nowrap transition-all
                ${
                  selectedValue === val.name
                    ? "bg-[#E6F0FF] text-[#1D4ED8] border border-[#1D4ED8]"
                    : "text-[#6B7280] hover:bg-gray-100"
                }`}
              >
                {t(val.name)}
              </div>
            ))}
          </div>

          <div className="flex-1 overflow-y-auto custom-scrollbar p-1 md:p-4">
            {data.map((val, i) => (
              <div
                key={i}
                className={val.name === selectedValue ? "block" : "hidden"}
              >
                {val.component}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserAccessManagement;

